import Resource from '@/plugins/sdk/Resource'
import { STRING, UUID, NUMBER, DATETIME, ITEM, COLLECTION } from '@/plugins/sdk/fields'
import Account from '@/plugins/sdk/resources/Account'
import IncumbentCarrier from '@/plugins/sdk/resources/Account/Lead/IncumbentCarrier'
import SuggestedCarrier from '@/plugins/sdk/resources/Account/Lead/SuggestedCarrier'
import Freight from '@/plugins/sdk/resources/Account/Lead/Freight'
import Event from '@/plugins/sdk/resources/Account/Event'
import Portfolio from '@/plugins/sdk/resources/Dictionary/Portfolio'

export default class extends Resource {
  static name = 'account_lead'

  static get fields () {
    return {
      id: new UUID(),
      status: new STRING(),
      worth: new NUMBER(),
      volume: new STRING(),
      reason: new STRING(),
      created_at: new DATETIME(),
      updated_at: new DATETIME(),
      deleted_at: new DATETIME(),
      account: new ITEM(Account),
      incumbent_carriers: new COLLECTION(IncumbentCarrier),
      suggested_carriers: new COLLECTION(SuggestedCarrier),
      freights: new COLLECTION(Freight),
      portfolio: new ITEM(Portfolio),
      events: new COLLECTION(Event)
    }
  }
}
